import { Injectable } from '@angular/core'
import { DateService } from './date.service'
import { FormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class InputMaskService {
  constructor(private dateService: DateService) {}

  /**
   * Validate date input mask
   * @param dateValue
   * @returns
   */
  validateDate(dateValue: string) {
    // Custom date validation logic
    const dateRegex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/

    if (dateRegex.test(dateValue)) {
      return true
    }
    return false
  }

  /**
   * Mask time validate
   * @param stringTime String time
   * @returns
   */
  validateTime(stringTime: string) {
    if (stringTime) {
      const splitted = stringTime?.split(':')
      if (Number.parseInt(splitted[0]) > 23) return false
      if (Number.parseInt(splitted[1]) > 59) return false
      return true
    }
    return true
  }

  /**
   * Check if time mask start time grater than finish time
   * @param startTime
   * @param finishTime
   * @returns
   */
  maskTimeValidateFirsTimeGreaterThanSecond(startTime: string, finishTime: string) {
    if (startTime && finishTime && this.validateTime(startTime) && this.validateTime(finishTime)) {
      if (this.dateService.convertTimeFromStringNormal(startTime) >= this.dateService.convertTimeFromStringNormal(finishTime)) {
        return false
      }
    }
    return true
  }

  /**
   * On mask date value change check date validate and update value in form control
   * @param value Date value
   * @param form Form group
   * @param controlName Control name
   */
  maskDateValueChange(value: { target: { value: string } }, form: FormGroup, controlName: string) {
    if (!this.validateDate(value.target.value)) {
      form.get(controlName)?.setValue(null)
    }
  }
}
